import { View } from 'react-native';
import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/hooks/useResponsiveDimensions';
import { ClickableWordSquare } from './index';
import { styles } from './styles';

type SplitWord = {
  key: string | number;
  i: number;
  word: string;
  order: number;
};

type ClickableWordSquareContainerProps = {
  splitWords: SplitWord[];
  onWrong: (onWrongParam: number) => void;
  onCorrect: (id: number, currentOrder: number, word: string) => void;
  currentOrder: number;
  guessedWords: number[];
  wrongBoxChosen: number;
};

export function ClickableWordSquareContainer({
  splitWords,
  onWrong,
  onCorrect,
  currentOrder,
  guessedWords,
  wrongBoxChosen,
}: ClickableWordSquareContainerProps) {
  // count the number of characters and words to calculate a good font size
  let choiceWordsLength = splitWords.length;
  let choicesWordsTotalCharacterCount = splitWords
    .map((choice) => choice.word)
    .join('').length;

  // get the width and height of the container to calculate a good font size
  let choicesWrapperHeight = useResponsiveHeight(20);
  let choicesWrapperWidth = useResponsiveWidth(100);
  let margin = useResponsiveWidth(1);
  let gap = useResponsiveWidth(1.5);

  // calculate a good font size for the choice word buttons based on words count, character count, screen width and ratio
  let size =
    ((choicesWrapperWidth - choiceWordsLength * margin) /
      choicesWordsTotalCharacterCount) *
    2.7;

  let screenRatio = choicesWrapperHeight / choicesWrapperWidth;
  // for potrait mode increase button size
  if (screenRatio > 0.5) {
    size = size * 2;
  }
  // if super wide screen decrease button size
  else if (screenRatio < 0.2) {
    size = size * 0.8;
  }
  // button font size can not be bigger then third the wrapper height
  size = Math.min(size, choicesWrapperHeight / 3);

  return (
    <View style={[styles.choicesWrapper, { gap }]}>
      {splitWords.map((eachIter, index) => {
        const { word: wordValue, order, key, i } = eachIter;

        return (
          <ClickableWordSquare
            key={key}
            id={i}
            isHidden={guessedWords.includes(i)}
            currentOrder={currentOrder}
            order={order}
            word={wordValue}
            onCorrect={onCorrect}
            onWrongParam={index}
            onWrong={onWrong}
            fontSize={size}
            margin={margin}
            wrongBoxChosen={wrongBoxChosen}
          />
        );
      })}
    </View>
  );
}
